module.exports = __webpack_public_path__ + "img/DAB_x_Bank_DKI.068d462f.jpeg";